<template>
  <div
    :class="
      isLoginPage || isRegisterPage ? 'login-lng-dropdown' : 'language-dropdown'
    "
  >
    <v-menu offset-y v-model="isMenuOpen">
      <template v-slot:activator="{ on, attrs }">
        <!-- Объединенная кнопка с текстом и стрелкой -->
        <div
          v-bind="attrs"
          v-on="on"
          class="language-button"
          :class="{ 'login-style': isLoginPage || isRegisterPage }"
        >
          <!-- Иконка для страниц логина/регистрации -->
          <span
            v-if="isLoginPage || isRegisterPage"
            class="lang-icon"
            v-html="loginLangSvg"
          />
          
          <!-- Текст названия языка -->
          <TextField
            tag="span"
            weight="500"
            hoverColor="#0056b3"
            :enableHover="true"
            class="language-text"
          >
            {{ currentLanguage }}
          </TextField>
          
          <!-- Стрелка dropdown -->
          <span
            :class="{ 'rotate-icon': isMenuOpen }"
            class="dropdown-arrow"
            v-html="dropdownSvg"
          />
        </div>
      </template>
      
      <v-list>
        <v-list-item-group v-model="model" color="indigo">
          <v-list-item
            v-for="language in languages"
            :key="language.code"
            @click="selectLanguage(language)"
          >
            <v-list-item-title>{{ language.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import dropdownSvg from "!!raw-loader!@/assets/dropdown-icon.svg";
import loginLangSvg from "!!raw-loader!@/assets/login-lang-icon.svg";

export default {
  props: {
    languages: {
      type: Array,
    },
    defaultLanguage: {
      type: String,
    },
  },
  data() {
    return {
      model: 0,
      isMenuOpen: false,
      currentLanguage: "",
      isLoginPage: false,
      isRegisterPage: false,
      dropdownSvg,
      loginLangSvg,
    };
  },
  mounted() {
    this.isLoginPage = this.$route.path === "/login";
    this.isRegisterPage = this.$route.path === "/registration";

    const savedLanguageCode =
      Cookies.get("zk_lng") || localStorage.getItem("zk_lng");

    let languageCodeToUse = savedLanguageCode;

    if (!languageCodeToUse) {
      const browserLang = navigator.language.slice(0, 2);
      const found = this.languages.find((l) => l.code === browserLang);
      languageCodeToUse = found ? browserLang : this.defaultLanguage;
    }

    this.setLanguageByCode(languageCodeToUse, false);
  },
  methods: {
    setLanguageByCode(languageCode, reload = true) {
      const language = this.languages.find(
        (lang) => lang.code === languageCode
      );
      if (language) {
        Cookies.set("zk_lng", language.code, { path: "/", expires: 365 });

        if (reload) {
          window.location.reload();
        } else {
          this.currentLanguage = language.name;
          this.model = this.languages.indexOf(language);
          this.$i18n.locale = language.code;
        }
      }
    },
    selectLanguage(language) {
      const currentLanguageCode = Cookies.get("zk_lng");
      if (language.code !== currentLanguageCode) {
        this.setLanguageByCode(language.code);
      }
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
/* Основной контейнер */
.language-dropdown {
  width: auto !important;
}

.login-lng-dropdown {
  display: flex;
  align-items: center;
}

/* Объединенная кнопка */
.language-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

/* Стиль для обычных страниц */
.language-button:not(.login-style) {
  background-color: transparent;
}

/* Стиль для страниц логина/регистрации */
.language-button.login-style {
  background-color: transparent;
  padding: 8px;
}

.language-button.login-style:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Текст языка */
.language-text {
  cursor: pointer;
  display: inline-block;
  min-width: 40px;
}

/* Стрелка dropdown */
.dropdown-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  vertical-align: middle;
}

.rotate-icon .dropdown-arrow {
  transform: rotate(180deg);
}

/* SVG стили */
::v-deep .dropdown-arrow svg {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

::v-deep .login-style .lang-icon svg {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

/* Стили для меню */
::v-deep .v-list-item {
  min-height: 40px;
}

::v-deep .v-list-item:hover {
  background-color: #f5f5f5;
}

/* Адаптивность */
@media (max-width: 768px) {
  .language-button {
    padding: 6px 10px;
  }
  
  .language-text {
    font-size: 14px;
  }
}
</style>